import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { SalesTeam } from '@user/store/salesTeam'
import { LeadAssignmentRuleFormModel } from '../../../../typings'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<LeadAssignmentRuleFormModel>()

  const handleChange = useCallback(
    (value: SalesTeam[] | null) => {
      const salesTeamsIds = value?.map((team) => team.id)
      setFieldValue(name, salesTeamsIds ?? [])
    },
    [setFieldValue, name],
  )

  return {
    handleChange,
  }
}
